import { Component, Vue, Prop, Watch } from 'vue-property-decorator';

@Component
export default class VAccountingTimelineItem extends Vue {
    public title: string = 'VAccountingTimelineItem';

    public getText() {
        if (this.item.type === 'OUT_INVOICE') {
            return 'CUSTOMER INVOICE';
        }
        if (this.item.type === 'IN_INVOICE') {
            return 'VENDOR INVOICE';
        }
        if (this.item.type === 'OUT_REFUND') {
            return 'CUSTOMER REFUND';
        }
        if (this.item.type === 'IN_REFUND') {
            return 'VENDOR REFUND';
        }
    }
    public getIcon() {
        if (this.item.type === 'OUT_INVOICE') {
            return 'icon-out';
        }
        if (this.item.type === 'IN_INVOICE') {
            return 'icon-in';
        }
        if (this.item.type === 'OUT_REFUND') {
            return 'icon-out-refound';
        }
        if (this.item.type === 'IN_REFUND') {
            return 'icon-in-refound';
        }
    }
    public getType() {
        if (this.item.type === 'OUT_INVOICE') {
            return 'type-out';
        }
        if (this.item.type === 'IN_INVOICE') {
            return 'type-in';
        }
        if (this.item.type === 'OUT_REFUND') {
            return 'type-out-refound';
        }
        if (this.item.type === 'IN_REFUND') {
            return 'type-in-refound';
        }
    }
    @Prop({ default: null })
    public item: any;

    @Watch('item', { immediate: true, deep: true })
    public onDataInput(val: any, oldVal: any) {
    }
}
